import axios from "axios";
import { get, isEmpty } from "lodash";

import { host } from "config";
import { STORAGE_KEYS } from "shared/constant";
import { defaultHeaders } from "shared/method";
import { roughLogOut } from "../session";
import { LOGIN, LOGOUT, ME, SEND_SMS, UPDATE_PASSWORD, VERIFY_SMS } from "./requestType";

export const getAuthOptionByType = (type, param = {}) => {
  let option = { url: "", method: "" };

  switch (type) {
    case LOGIN:
      option.method = "POST";
      option.url = `${host}/backend/login`;
      option.params = param.qs;
      option.data = param.body;
      break;
    case LOGOUT:
      option.method = "GET";
      option.url = `${host}/backend/logout`;
      break;
    case VERIFY_SMS:
      option.method = "POST";
      option.url = `${host}/backend/verify-code`;
      option.data = param.body;
      break;
    case SEND_SMS:
      option.method = "POST";
      option.url = `${host}/backend/send-verify`;
      option.data = param.body;
      break;
    case ME:
      option.method = "GET";
      option.url = `${host}/backend/user`;
      break;
    case UPDATE_PASSWORD:
      option.method = "PATCH";
      option.url = `${host}/backend/password/${param.id}`;
      option.data = param.body;
      break;
    default:
      return {};
  }
  return option;
};

export const authProvider = (type, options) => {
  const option = getAuthOptionByType(type, options);
  if (isEmpty(option)) throw Error("no match request type");

  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
  const headers =
    type === LOGIN
      ? {
          "Content-Type": "application/json"
        }
      : defaultHeaders();
  if (token) headers.Authorization = `Bearer ${token}`;

  return axios({
    ...option,
    headers
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      // 這裡加入條件：如果是 LOGIN 失敗，不執行 roughLogOut()
      if (type !== LOGIN) {
        roughLogOut();
      }
      return {
        err: true,
        status: get(error, "response.status"),
        message: get(error, "response.data") || error.message
      };
    });
};
